<template>
  <!-- Cabecera de la plantilla: datos del proyecto (solo lectura) + campos manuales. -->
  <div class="prm-header">
    <div class="block">
      <div class="company">{{ meta.company || '—' }}</div>
      <div class="project">{{ meta.projectName }}</div>
      <div class="code">
        {{ $t('prm_code') }}:
        <input class="inline-input" :class="{ 'is-changed': changed.sapCode }" :style="{ minWidth: chWidth(meta.sapCode) }"
               :value="meta.sapCode" @input="queue('sapCode', $event.target.value)">
      </div>
    </div>

    <div class="block bridges">
      <div class="field"><span>{{ $t('prm_total_bridges') }}</span>
        <input class="inline-input" :class="{ 'is-changed': changed.totalBridges }" :style="{ minWidth: chWidth(meta.totalBridges) }"
               :value="meta.totalBridges" @input="queue('totalBridges', $event.target.value)"></div>
      <div class="field"><span>{{ $t('prm_pbbs_shipped') }}</span>
        <input class="inline-input" :class="{ 'is-changed': changed.pbbsShipped }" :style="{ minWidth: chWidth(meta.pbbsShipped) }"
               :value="meta.pbbsShipped" @input="queue('pbbsShipped', $event.target.value)"></div>
      <div class="field"><span>{{ $t('prm_pbbs_stored') }}</span>
        <input class="inline-input" :class="{ 'is-changed': changed.pbbsStored }" :style="{ minWidth: chWidth(meta.pbbsStored) }"
               :value="meta.pbbsStored" @input="queue('pbbsStored', $event.target.value)"></div>
    </div>

    <div class="block signatures">
      <div v-for="sig in signatureFields" :key="sig.key" class="field col">
        <span>{{ $t(sig.label) }}</span>
        <input class="inline-input" :class="{ 'is-changed': changed['sig:' + sig.key] }" :style="{ minWidth: chWidth((meta.signatures || {})[sig.key]) }"
               :value="(meta.signatures || {})[sig.key]" @input="queueSig(sig.key, $event.target.value)">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PrmTemplateHeader',
    props: {
      meta: { type: Object, required: true },
      resetKey: { type: Number, default: 0 }, // cambia en cada carga → limpia resaltados
    },
    data: () => ({
      changed: {}, // campos meta cambiados en la sesión (para el underline)
      timers: {},  // debounce por campo (guardado en vivo, sin depender del foco)
      signatureFields: [
        { key: 'projectManager', label: 'prm_project_manager' },
        { key: 'projectDirection', label: 'prm_project_direction' },
        { key: 'controlling', label: 'prm_controlling' },
        { key: 'financeDirector', label: 'prm_finance_director' },
      ],
    }),
    watch: {
      resetKey () { this.changed = {} }, // nueva sesión / import: se limpian los resaltados
    },
    // Al desmontar (cambio de tab/proyecto), volcamos cualquier edición pendiente.
    beforeDestroy () { this.flush() },
    methods: {
      // Guardado EN VIVO con debounce: no depende de que el input pierda el foco, así
      // la última firma que edites antes de exportar también se guarda.
      queue (key, value) { this.debounce(key, () => this.save(key, value)) },
      queueSig (key, value) { this.debounce('sig:' + key, () => this.saveSignature(key, value)) },
      debounce (id, fn) {
        const prev = this.timers[id]
        if (prev) clearTimeout(prev.t)
        this.timers[id] = { fn, t: setTimeout(() => { this.timers[id] = null; fn() }, 500) }
      },
      // Dispara YA todos los guardados pendientes (lo llama el padre antes de exportar).
      flush () {
        Object.keys(this.timers).forEach((id) => {
          const e = this.timers[id]
          if (e) { clearTimeout(e.t); this.timers[id] = null; e.fn() }
        })
      },
      save (key, value) {
        this.$set(this.changed, key, true)
        this.$emit('save-meta', { [key]: value })
      },
      saveSignature (key, value) {
        this.$set(this.changed, 'sig:' + key, true)
        // Mandamos SOLO la firma cambiada; el backend la fusiona (no reemplaza el objeto).
        this.$emit('save-meta', { signatures: { [key]: value } })
      },
      // Ancho aproximado al contenido (entre 12 y 42 ch) para que no se corte el texto.
      chWidth (v) {
        const len = String(v == null ? '' : v).length
        return Math.min(42, Math.max(12, len + 2)) + 'ch'
      },
    },
  }
</script>

<style lang="scss" scoped>
  .prm-header {
    display: flex; flex-wrap: wrap; justify-content: space-between; gap: 24px;
    border: 1px solid #d4dae3; border-bottom: 0; border-radius: 8px 8px 0 0;
    background: #fff; padding: 12px 16px;
  }
  .company { font-size: 10px; text-transform: uppercase; letter-spacing: .04em; color: #9aa4b2; }
  .project { font-size: 15px; font-weight: 700; color: #1e3046; }
  .code { font-size: 11px; color: #6b7787; }

  .bridges, .signatures { font-size: 11px; }
  .signatures { display: grid; grid-template-columns: 1fr 1fr; gap: 2px 24px; }
  .field { display: flex; gap: 8px; align-items: baseline; }
  .field.col { flex-direction: column; gap: 0; }
  .field > span { color: #9aa4b2; min-width: 110px; }

  .inline-input {
    border: 0; border-bottom: 1px solid transparent; background: transparent;
    color: #33475f; font-size: 11px; outline: none; min-width: 60px;
  }
  .inline-input:hover, .inline-input:focus { border-bottom-color: #b9cde0; }
  // Campo meta cambiado en la sesión: underline ámbar persistente.
  .inline-input.is-changed { border-bottom-color: #d4a017; }
</style>
